import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import withAuth from '../hocs/withAuth';
var AuthLayout = function () {
    return (_jsx("div", { className: 'w-screen h-screen flex justify-center items-center', children: _jsx(Outlet, {}) }));
};
export default withAuth(AuthLayout);
